<template>
  <div id="personalct" class="contentmodaldiv" data-backdrop="false">
    <div class="modaldiv">
      <div class="contentmodal animate__animated animate__bounceInDown">
        <button class="closepopup" data-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
        <div class="login">
          <div class="logopopup">
            <img src="/static/img/logo/main_logo_20221004223046.png" />
          </div>
          <h1>ข้อมูลส่วนตัว</h1>
          <div class="detailuser">
            <table>
              <tbody>
                <tr>
                  <td><i class="fas fa-user"></i></td>
                  <td>
                    {{ UserInfo.userName.fullName }}
                  </td>
                </tr>
                <tr>
                  <td><i class="fas fa-phone-alt"></i></td>
                  <td>
                    {{ UserInfo.PhoneNumber }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <img
                      :style="{
                        'background-color': getBankColorwithCode(
                          UserInfo.BankCode
                        ),
                        padding:
                          UserInfo.BankCode == 'co.th.truemoney.wallet'
                            ? ''
                            : '5px',
                      }"
                      v-bind:src="getBankImgwithCode(UserInfo.BankCode)"
                      class="img-rounded img-responsive"
                    />
                  </td>
                  <td>
                    {{ UserInfo.BankAccount | formatAccNo }}
                  </td>
                </tr>
                <tr>
                  <td>
                    ยูส
                  </td>
                  <td>
                    {{ UserInfo.PhoneNumber }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <a
              href="javascript:void(0)"
              @click="sign_out()"
              id="btnLogin"
              class="btnLogin"
              >ออกจากระบบ</a
            >
          </div>
        </div>
      </div>
      <div class="overlaymodal"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { fetchAffiliate, WithdrawAffiliate } from "@/services/modules/af.js";
import MemberCard from "@/components/form/MemberCard";
import { fetchBonus } from "@/services/modules/promotion.js";
import api from "@/services/index.js";

export default {
  name: "ProfileForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      amount: "",
      bonusName: "-",
      promotionList: [],
      affiliateLink: "",
    };
  },
  components: {
    MemberCard,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPrefix",
    ]),
  },
  methods: {
    ...mapActions(["userSignOut"]),
    async sign_out() {
      this.userSignOut();
    },
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copybank(item) {
      this.$copyText(item, this.$refs.withdraw);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },

    async copyAF(item) {
      this.$copyText(item, this.$refs.af);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchAffiliate() {
      await fetchAffiliate((res) => {
        if (res.status) {
          this.income = res.data.balance;
          this.Trans = res.data.transaction;
          this.Users = res.data.Users;
          this.TransIncome = res.data.transaction_incomes;
          this.setting = res.data.setting;
        }
      });
    },

    async WithdrawAffiliate() {
      await WithdrawAffiliate((res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },

    async PromotionData() {
      // this.setLoading(true)
      await fetchBonus((res) => {
        if (res.status) {
          this.promotionList = res.data;
        } else {
        }
      });
    },
    async getUserRefresh(Loading) {
      await api
        .get("/auth-service/v1/refresh")
        .then((v) => {
          if (this.UserInfo.BonusInfo.isBonus) {
            if (this.promotionList.length > 0) {
              let promotionItem = this.promotionList.find(
                (x) => x._id === this.UserInfo.BonusInfo.bonusId
              );
              if (promotionItem != undefined) {
                this.bonusName = promotionItem.title;
              } else {
                this.bonusName = "-";
              }
            }
          }
        })
        .catch((e) => {
          this.$swal.fire(e.message, "", "error");
        })
        .finally(() => {});
    },
  },
  async mounted() {
    await this.PromotionData();
    await this.fetchAffiliate();
    this.affiliateLink = "";
    this.affiliateLink =
      window.location.origin + "/" + this.UserInfo.affiliateKey;
    $(".overlaymodal").on("click", function() {
      $("#personalct").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/ProfileForm.vue